import React, {useState} from 'react';
import hideAlert from './utils/hideAlert';
import isAlertVisible from './utils/isAlertVisible';
import {ConfirmDialog} from '../';
import {useFnGamesTour} from '../../pages/fortnite-games/FnGamesTourProvider';
import {AlertCta} from './Alert';
import {AlertComponentType} from './types';

export interface AlertPopupProps {
    type: string;
    title?: string;
    cta?: AlertCta;
    message: React.ReactNode;
}

const CODES = {
    title: 'epic.affiliate.common.sacName',
    continue: 'epic.affiliate.settings.tax.profile.continue.creator.v2'
};

const AlertPopup: React.FC<AlertPopupProps> = ({type, title, cta, message}) => {
    const [open, setOpen] = useState(true);

    // Show Fortnite Games tour modal only when other ones are closed
    const {notifyModalClose} = useFnGamesTour();

    if (!isAlertVisible(type, AlertComponentType.HIDE_POPUP)) {
        return null;
    }

    const {message: ctaMessage, code, link, onClick} = cta || {};

    const closeAlert = () => {
        setOpen(false);
        hideAlert(type, AlertComponentType.HIDE_POPUP);
        notifyModalClose();
    };

    return (
        <ConfirmDialog
            open={open}
            title={title || CODES.title}
            cancel={CODES.continue}
            submit={code ? code : <>{ctaMessage}</>}
            submitRedirectPath={link}
            onClose={() => closeAlert()}
            onSubmit={() => {
                closeAlert();
                if (typeof onClick === 'function') {
                    onClick();
                }
            }}
            dialogContentTextProps={{
                align: 'center'
            }}>
            {typeof message === 'string' ? (
                <p dangerouslySetInnerHTML={{__html: message}} />
            ) : (
                message
            )}
        </ConfirmDialog>
    );
};

export default AlertPopup;
